import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getAllProofTags(context) {
    return axios
      .get("proofTag")
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  createProofTag(context, value) {
    return axios
      .post("proofTag", value)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.tag.createdMessage", { name: r.data.tag }));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateProofTag(context, value) {
    return axios
      .put("proofTag/" + value.id, value)
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteProofTag(context, value) {
    return axios
      .delete("proofTag/" + value.id)
      .then((r) => r)
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
